<a class="button" routerLink="/support" *ngIf="!anyModalOpen()">
  <span class="pi pi-question"></span>
</a>
